import ApiCall from "../constants/Api";
import SiteConfig from "../constants/SiteConfig";
import { helpAxios } from "../helpers/helpAxios";
import { errorHandler } from "../components/ErrorHandler";

export const useSelectFunctions = () => {
  //GetVoidReasonList function
  const getVoidReasonList = async (session) => {
    let response;
    try {
      response = await helpAxios(
        SiteConfig.RACING_TICKET_VALIDATOR_SVC,
        ApiCall.GET_VOID_REASON_LIST,
        {},
        session
      );

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  return {
    getVoidReasonList,
  };
};
